module.exports = __webpack_public_path__ + "static/media/ins-4.11510270.webp";